module.exports = __webpack_public_path__ + "img/default.31608435.png";